module.exports = __webpack_public_path__ + "img/nz.bfc21600.svg";